import { Injectable } from '@angular/core';
import {MatSnackBar} from "@angular/material/snack-bar";
import {ErrorComponent} from "../component/error/error.component";
import {BehaviorSubject, Observable} from "rxjs";

@Injectable()
export class ErrorService {

  private spinner$ = new BehaviorSubject<string>('');
  constructor(private snackBar: MatSnackBar) {}

  openSnackBar(){
    this.snackBar.openFromComponent(ErrorComponent,{
      panelClass: ['error-snackbar'],
      horizontalPosition: "right",
      verticalPosition: "bottom",
      duration: 5000,
      data: {preClose: () => this.snackBar.dismiss()}
    })
  }

  getSpinnerObserver(): Observable<string> {
    return this.spinner$.asObservable();
  }

  error() {
      this.spinner$.next('start');
  }


}
